import {
    SET_FIELD,
    CALCULATE,
    CALCULATE_INCOME,
    GET_BANK_BY_ID,
    CALCULATE_YEARLY_INCOME,
    CALCULATE_YEARLY_INCOME_INDEPENDENT,
    GET_MORTGAGE_PROVIDER,
    SHARE_PDF,
    RESET_STEPS,
    SET_OTHER_BANK,
} from "../actionTypes/calculatorActionTypes";
import {getInitialState} from "../../services/stateHelper";

export const initialState = getInitialState();

const calculatorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FIELD:
            return {
                ...state,
                [action.field]: action.value,
            };

        case CALCULATE:
            return {
                ...state,
                response: {
                    ...state.response,
                    ...action.response
                }
            };

        case SHARE_PDF:
            return {
                ...state,
                sharePdf: {
                    ...state.sharePdf,
                    ...action.response
                },
            };

        case CALCULATE_YEARLY_INCOME:
            return {
                ...state,
                [action.field]: action.response.yearlyIncome,
            };

        case CALCULATE_YEARLY_INCOME_INDEPENDENT:
            const yearlyIncomeIndependent = parseFloat(action.response.it);

            return {
                ...state,
                [action.field]:
                    yearlyIncomeIndependent % 1 !== 0
                        ? yearlyIncomeIndependent.toFixed(2)
                        : yearlyIncomeIndependent,
            };

        case CALCULATE_INCOME:
            return {
                ...state,
                Interest: (state.SelectedMortgageProvider) ? state.SelectedMortgageProvider.rentestand : action.response.interest,
                response: {
                    ...state.response,
                    ...action.response,
                    //BrutoMaandlasten: action?.response?.MonthlyCosts?.GrossMonthlyCosts,
                },
            };

      case GET_MORTGAGE_PROVIDER:

            return {
                ...state,
                Interest: action.response.rentestand,
                RentevastePeriode: action.response.rentevastePeriode,
                MortgageType: action.response.hypotheekVorm,
                SelectedMortgageProvider: (typeof state.SelectedMortgageProvider === "object") ? {...state.SelectedMortgageProvider, ...action.response } : action.response
            };

        case GET_BANK_BY_ID:

            return {
                ...state,
                InterestBestDeal: action.bankData.mainBank.rentestand,
                bankData: action.bankData,
            };

        case RESET_STEPS:
            return {
                ...getInitialState()
            };
      case SET_OTHER_BANK:

            // remove or add check action.action
            if (action.action === "add") {
              state.bankData.otherBanks.push(action.bank);
            } else {
              state.bankData.otherBanks = state.bankData.otherBanks.filter((bank) => bank.lookupId !== action.bank.lookupId)
            }
            const bankData = state.bankData;

            return {
              ...state,
              bankData: bankData
            };



        default:
            return state;
    }
};

export default calculatorReducer;
